import { GetListsResponseDTO } from '@gearbelt/global';
import { AccessorKeyColumnDef, createColumnHelper } from '@tanstack/react-table';

import { Checkbox } from '@/components/ui/checkbox';

const columnHelper = createColumnHelper<GetListsResponseDTO['data'][number]>();

export const columns = [
  columnHelper.display({
    id: 'select',
    header: ({ table }) => (
      <div className="flex w-full justify-center">
        <label className="-m-2 p-2">
          <Checkbox checked={table.getIsAllPageRowsSelected()} onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)} aria-label="Select all" />
        </label>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex w-full justify-center">
        <label className="-m-2 p-2" onClick={(e) => e.stopPropagation()}>
          <Checkbox checked={row.getIsSelected()} onCheckedChange={(value) => row.toggleSelected(!!value)} aria-label="Select row" />
        </label>
      </div>
    ),
    meta: {
      cellClassName: 'w-[40px] min-w-[40px] max-w-[40px]',
    },
    enableSorting: false,
    enableHiding: false,
  }),
  columnHelper.accessor('name', {
    id: 'name',
    header: 'List Name',
  }),
  columnHelper.accessor('id', {
    id: 'id',
    header: 'List ID',
  }),
  columnHelper.accessor('description', {
    id: 'description',
    header: 'Description',
    cell: ({ getValue }) => {
      const description = getValue();
      return <div className="w-full max-w-[300px] truncate">{description || '-'}</div>;
    },
  }),
  columnHelper.accessor('elements', {
    id: 'elementCount',
    header: 'Items',
    cell: ({ getValue }) => {
      const elements = getValue() as string[] | undefined;
      return <span>{elements?.length}</span>;
    },
  }),
] as AccessorKeyColumnDef<GetListsResponseDTO['data'][number]>[];
